import type { RxJsonSchema } from 'rxdb';
import type { ComponentType } from './componentType.types';

export const componentTypeSchema: RxJsonSchema<ComponentType> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
    abbrv: { type: ['string', 'null'] },
    assetCategory: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
  },
};
